import React from 'react'
import { ReactComponent as LoaderIcon } from 'static/icons/loader.svg'
import useStyles from './styles'


const Loader = () => {
  const localClasses = useStyles()

  return (
    <div className={localClasses.loaderWrapper}>
      <div className={localClasses.logoLoader}>
        <LoaderIcon />
      </div>
    </div>
  )
}

export default Loader
